import styled from 'styled-components';
import { StyleVars, spacingUnits, getColor } from 'core/utils';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.05);

	@media (max-width: ${StyleVars.desktopScreenSm}) {
		box-shadow: none;
	}
`;

export const Top = styled.div`
	display: flex;
	align-content: stretch;
	width: 100%;

	padding: ${spacingUnits(1/2)} ${spacingUnits(1.5)} ${spacingUnits(1/2)} ${spacingUnits(1)};
	max-width: ${StyleVars.screenCjDesktopMd};
	position: relative;

	@media (max-width: ${StyleVars.desktopScreenSm}) {
		flex-wrap: wrap;
		padding: ${spacingUnits(1/2)} ${spacingUnits(1)} 0;
	}
`;

/* Holiday logo change required height change 34px -> 48px, revert in 2023 */
export const LogoLink = styled.a`
	display: block;
	align-self: center;
	height: 48px; /* Revert to 34px in 2023  */
	> svg {
		height: 48px; /* Revert to 34px in 2023  */
	}
	margin-right: auto;
`;

export const SearchWrapper = styled.div`
	flex: 1 0 auto;
	align-self: center;
	padding: 0 28px;
	height: auto;

	@media (max-width: ${StyleVars.desktopScreenSm}) {
		order: 3;
		width: 100%;
		padding: 0;
		margin-top: 10px;
		margin-left: -16px;
		margin-right: -16px;
	}
`;

export const UserSpace = styled.div`
	display: flex;
`;

export const UserButtonWrapper = styled.div`
	color: ${getColor('black')};
	min-width: 32px;
	min-height: 34px;
	position: relative;
	display: flex;
	align-self: stretch;
	flex-direction: column;
	justify-content: ${clientSide => clientSide ? 'center' : 'end'};
	align-items: center;
`;
